import { loadImageFromBlobUrl } from '@nova/utils';
import { ExtensionType, LoaderParser, LoaderParserPriority, Texture } from 'pixi.js';

/** Pass to `Assets.load({ parser: BLOB_TEXTURE_LOADER_ID, ... })` for blob: image URLs. */
export const BLOB_TEXTURE_LOADER_ID = 'loadBlobTexture';

/**
 * Loads object/blob URLs as Pixi textures via HTMLImageElement (see @nova/utils loadImageFromBlobUrl).
 * Registered with AssetManager so local map preparers can use Assets.load with explicit `parser`.
 */
export const loadBlobTexture = {
  id: BLOB_TEXTURE_LOADER_ID,
  name: BLOB_TEXTURE_LOADER_ID,

  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.High
  },

  test(url: string): boolean {
    return url.startsWith('blob:');
  },

  async load(url: string): Promise<Texture> {
    const img = await loadImageFromBlobUrl(url);
    if (!img) {
      throw new Error('loadBlobTexture: failed to decode image from blob URL');
    }
    return Texture.from(img);
  },

  unload(texture: Texture): void {
    texture.destroy(true);
  }
} as LoaderParser;
